import { zergApi } from "@/service/zerg";
import axios from "axios";

class PayrollService {

    async getPayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/driver/get-payroll", params);
            return data;
        } catch (error) {
            throw error;
        }
    };

    async calculatePayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/driver/calculate-payroll", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async calculateMonthlyPayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/driver/calculate-monthly-payroll", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async calculateEndOfMonthPayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/driver/calculate-end-of-month-payroll", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getPayrollTracking(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/driver/get-payroll-tracking", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDataOperationPayrollById(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/driver/get-data-operation-payroll-by-id", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async addDiscountToOperationPayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/driver/add-discount-to-operation-payroll", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getAttendanceForPayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/driver/get-attendance-for-payroll", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async approveDriverPayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/driver/approve-driver-payroll", params);
            return data;
        } catch (error) {
            throw error;
        }
    }
    async consultarPlanillaConductor(batchId) {
        try {
            const { data } = await zergApi.get(`/rrhh/payroll/driver/consultar-planilla-conductor/${batchId}`);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async anularPlanillaConductor(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/driver/anular-planilla", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async generatePaymentInOldSoft(params) {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded' // Aquí puedes cambiar el tipo de contenido
                }
            };
            const data = await axios.post('https://old.rosymarperu.in/server/public/index.php/cronjob/tareo/generate_payment_fortnight', params, config)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async createCajaPlanilla(params) {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded' // Aquí puedes cambiar el tipo de contenido
                }
            };
            const data = await axios.post('https://old.rosymarperu.in/server/public/index.php/cronjob/tareo/generar_caja_planilla', params, config)
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new PayrollService();